<template>
  <div v-cloak>
    <h6 class="warn">差异建议线下沟通后，联系采购商修改来源单</h6>
    <ul>
      <li class="liNO1">
        <div>条目</div>
        <div>采购单</div>
        <div>入库/仓退单</div>
      </li>
      <li class="li">
        <div>单价（不含税）</div>
        <div>{{ ulData.purUnTaxPrice }}</div>
        <div>{{ ulData.storeUnTaxPrice }}</div>
      </li>
      <li class="li">
        <div>税种</div>
        <div>{{ ulData.purTaxTypeName }}</div>
        <div>{{ ulData.storeTaxTypeName }}</div>
      </li>
      <li class="li">
        <div>税率</div>
        <div>{{ ulData.purTaxRate }}</div>
        <div>{{ ulData.storeTaxRate }}</div>
      </li>
      <li class="li">
        <div>单价（含税</div>
        <div>{{ ulData.purTaxPrice }}</div>
        <div>{{ ulData.storeTaxPrice }}</div>
      </li>
      <li class="li">
        <div>计价数量</div>
        <div>{{ ulData.purValuationQty }}</div>
        <div>{{ ulData.storeValuationQty }}</div>
      </li>
      <li class="li">
        <div>采购金额</div>
        <div>{{ ulData.purAmount }}</div>
        <div>{{ ulData.storeAmount }}</div>
      </li>
      <li class="li">
        <div>来源</div>
        <div>采购单</div>
        <div>{{ ulData.storeSourceTypeName }}</div>
      </li>
      <li class="li">
        <div>来源单号</div>
        <div>{{ ulData.purSourceNo }}</div>
        <div>{{ ulData.storeSourceNo }}</div>
      </li>
      <li class="li">
        <div>处理方式</div>
        <div>{{ ulData.purManageType }}</div>
        <div>{{ ulData.storeManageType }}</div>
      </li>
      <li class="li">
        <div>付款条件</div>
        <div>{{ ulData.purPayTermsName }}</div>
        <div>{{ ulData.storePayTermsName }}</div>
      </li>
      <li class="li">
        <div>价格条件</div>
        <div>{{ ulData.purPriceConditionName }}</div>
        <div />
      </li>
      <li class="li">
        <div>币种</div>
        <div>{{ ulData.purCurrencyName }}</div>
        <div>{{ ulData.storeCurrencyName }}</div>
      </li>
      <li class="chayi"><div>差异原因: </div><el-input v-model="ulData.diffReason" placeholder="请输入差异原因" type="textarea" /></li>
      <li class="invoiceAmount">
        <div class="invoiceAmount-item">
          <div class="box" v-text="ulData.invoicedQty >= 0 && ulData.invoicedQty !== null ? &quot;已开票&quot; : &quot;未开票&quot;" />
          <div class="box-item">已开票数量: {{ ulData.invoicedQty }}</div>
          <div class="box-item">未开票数量: {{ ulData.unInvoiceQty }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getBillDetailInfo } from '@/api/bill'
export default {
  props: {
    data: {
      type: Object,
      default: () => []
    }
  },
  data() {
    return {
      ulData: {
        'ent': '',
        'site': '',
        'siteName': '',
        'plantNo': '',
        'plantName': '',
        'supplierNo': '',
        'supplierName': '',
        'purUnTaxPrice': '',
        'storeUnTaxPrice': '',
        'purTaxPrice': '',
        'storeTaxPrice': '',
        'purAmount': '',
        'storeAmount': '',
        'purValuationQty': '',
        'storeValuationQty': '',
        'purTaxTypeNo': '',
        'purTaxTypeName': '',
        'storeTaxTypeNo': '',
        'storeTaxTypeName': '',
        'purTaxRate': '',
        'storeTaxRate': '',
        'purPayTermsNo': '',
        'purPayTermsName': null,
        'storePayTermsNo': '',
        'storePayTermsName': '',
        'purPriceConditionNo': '',
        'purPriceConditionName': '',
        'purSourceTypeName': '',
        'storeSourceTypeName': '',
        'purSourceNo': '',
        'storeSourceNo': '',
        'purManageType': null,
        'storeManageType': null,
        'purCurrencyNo': '',
        'purCurrencyName': '',
        'storeCurrencyNo': '',
        'storeCurrencyName': '',
        'diffReason': null,
        'invoicedQty': null,
        'unInvoiceQty': null,
        'diffSign': null,
        'purConfirmSign': null,
        'supConfirmSign': null,
        'purchaseUnitName': ''
      }
    }
  },
  watch: {
    data(n) {
      console.log(n)
      this.data = n
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      console.log(this.data)
      const data = {
        'condition': {
          'plantList': ['SP2'],
          'sourceNo': this.data.sourceNo,
          'sourceSeq': this.data.sourceSeq,
          'ent': 'sp2',
          'siteList': ['SP2']
        },
        'current': 1,
        'size': 20
      }
      this.ulData = await getBillDetailInfo(data)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
  .liNO1 {
    display: flex;
    padding-left: 80px;
    background-color: #e9f3fe;
    margin-bottom: 10px;
    div {
      line-height: 36px;
      flex: 1;
      color: #333333;
      font-size: 14px;
      font-weight: 550;
    }
  }
  .li {
    padding-left: 80px;
    height: 36px;
    list-style: none;
    display: flex;
    margin-bottom: 10px;
    border-bottom: 1px solid #f5f5f5;
    div {
      flex: 1;
      font-size: 12px;
      color: #333333;
      line-height: 36px;
    }
  }
  .invoiceAmount {
    display: flex;
    list-style: none;
    color: #3aa6e7;
    margin-bottom: 10px;
    .invoiceAmount-item {
      display: flex;
      box-sizing: border-box;
      padding-left: 20px;
      width: 404px;
      height: 50px;
      background: #f5f6f8;
      border-radius: 20px;
      .box {
        margin-right: 20px;
        line-height: 50px;
        font-size: 15px;
        color: #008ee3;
        font-weight: 550;
      }
      .box-item {
        flex: 1;
        display: flex;
        line-height: 50px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }
    }
  }
  .chayi {
    padding-left: 10px;
    margin-bottom: 15px;
    div {
      display: inline-block;
      color: #666666;
      font-size: 13px;
      margin-bottom: 10px;
    }
    .el-input {
      width: 400px;
    }
  }
}
.warn {
  margin: 0px;
  margin-bottom: 10px;
  height: 34px;
  background: #FFF3EA;
  line-height: 34px;
  color: #FA6400;
  padding-left: 20px;
  }
.el-dialog__header {
  padding-bottom: 10px;
}
</style>
